import { render, staticRenderFns } from "./vFooter.vue?vue&type=template&id=68210572&"
import script from "./vFooter.vue?vue&type=script&lang=js&"
export * from "./vFooter.vue?vue&type=script&lang=js&"
import style0 from "./vFooter.vue?vue&type=style&index=0&id=68210572&prod&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports